import * as React from "react";
import { CheckCircle } from "@/components/shared/icons";
import { cn } from "@/lib/utils";
import * as RadioGroupPrimitive from "@radix-ui/react-radio-group";

import { View } from "../view";

const RadioGroup = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>
>(({ className, ...props }, ref) => {
  return <RadioGroupPrimitive.Root className={cn("grid gap-2", className)} {...props} ref={ref} />;
});
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;

const RadioGroupItem = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item> & {
    checkCircle?: boolean;
    size?: "sm" | "md";
  }
>(({ className, checkCircle, size = "md", ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Item
      ref={ref}
      className={cn(
        "aspect-square h-4 w-4 rounded-full disabled:cursor-not-allowed disabled:opacity-50",
        checkCircle
          ? "border-secondary-border focus:outline-primary-border border"
          : "border-primary text-primary focus-visible:ring-ring border shadow focus:outline-none focus-visible:ring-1",
        "data-[state=checked]:border-none",
        className,
      )}
      {...props}
    >
      <RadioGroupPrimitive.Indicator className="flex items-center justify-center">
        {checkCircle ? (
          <CheckCircle
            weight="fill"
            size={size === "md" ? 18 : 16}
            className="text-primary hover:text-primary-hover shrink-0"
          />
        ) : (
          <View
            className={cn(
              "bg-primary hover:bg-primary-hover aspect-square rounded-full",
              size === "md"
                ? "native:h-[10] native:w-[10] h-[9px] w-[9px]"
                : "native:h-[8] native:w-[8] h-[7px] w-[7px]",
            )}
          />
        )}
      </RadioGroupPrimitive.Indicator>
    </RadioGroupPrimitive.Item>
  );
});

RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;

export { RadioGroup, RadioGroupItem };
